import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { Subject } from 'rxjs/internal/Subject';
import { getStepDetails } from '../../store/selectors/sub-task-details.selectors';
import { takeUntil } from 'rxjs/operators';
import { AppServicesLibraryService } from 'app-services-library';

@Component({
  selector: 'app-letter-generation-entry',
  templateUrl: './letter-generation-entry.component.html',
  styleUrls: ['./letter-generation-entry.component.scss']
})
export class LetterGenerationEntryComponent implements OnInit, OnDestroy {
  disabledControls: boolean;
  stepDetails: TaskStep;
  observableSubscription$ = new Subject();
  templateValue: number;

  @Output()
  redirectionComponent: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private store: Store<any>,
    public dynamicDialogRef: DynamicDialogRef,
    public dynamicDialogConfig: DynamicDialogConfig,
    private appServicesLibraryService: AppServicesLibraryService
  ) {
    this.disabledControls = false;
  }

  ngOnInit(): void {
    // Get Specific step details by passing step code
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      this.stepDetails = data;
      this.toggleControlsStatus();
    });
  }

  //Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
  }


  handleSelection() {
    if (this.templateValue === 0) {
      this.redirectionComponent.emit("LetterTemplate");
    } else {
      this.redirectionComponent.emit("CreateTemplate");
    }
    // if (value === 0) {
    //   this.redirectionComponent.emit("LetterTemplate");
    // } else {
    //   this.redirectionComponent.emit("CreateTemplate");
    // }
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

}
